<template>
  <div
    v-if="step"
    class="w-screen h-screen z-50 flex justify-center items-center bottom-0 left-0 fixed bg-gray-400 bg-opacity-80 overflow-auto"
  >
    <div
      class="w-10/12 lg:w-75 md:w-10/12 max-w-lg h-10/12 bg-white rounded-md md:p-10 flex flex-col grid grid-cols-1 mt-20"
    >
      <div>
        <div class="text-right" @click="closeModal()">
          <span class="cursor-pointer font-bold hover:text-sirit_blue-400"
            >x</span
          >
        </div>
        <h1 class="text-4xl font-medium mt-2 mb-10 text-center">
          Elije los servicios que quieres contratar con nocotros
        </h1>
      </div>
      <form @submit.prevent="submit">
        <div class="w-full grid grid-cols-1 sm:grid-cols-2 gap-3 text-left">
          <div class="flex flex-col">
            <span class="text-xl font-bold pt-3"
              >Servicio Gestión Amistosa</span
            >
            <input
              id="input-company"
              @change="setDate()"
              v-model="data_.day"
              type="check"
              class="boder w-full h-5 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-rose-500 rounded-md border-2 px-3"
              required
            />
          </div>
          <div class="flex flex-col">
            <span class="text-xl font-bold pt-3 ml-1"
              >Servicio de Recuperación Legal</span
            >
            <input
              id="input-cif"
              @change="setDate()"
              v-model="data_.month"
              type="number"
              min="1"
              max="12"
              autocomplete="off"
              placeholder="mm"
              class="boder w-full h-5 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-1 focus:ring-rose-500 rounded-md border-2 p-3"
              required
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { reactive } from "vue";
import axios from "axios";
import { getToken, getFormatDateComplete } from "../../api/global";

export default {
  name: "NewServicesModal",
  props: {
    step: { type: Boolean, required: true, default: false },
    debtorCaseId: { type: Number, required: true, default: 0 },
  },
  emits: ["onFire"],
  setup(props: any, { emit }: any) {
    const closeModal = () => {
      emit("onFire");
    };

    const data_ = reactive({
      day: "",
      month: "",
      year: "",
    });

    const dataTransfer = reactive({
      debtorCaseId: 0,
      amount: 0,
      concept: "",
      date: "2022-02-23T11:30:27.222Z",
      qualification: "",
      operationDate: "2022-02-23T11:30:27.222Z",
    });

    const setDate = () => {
      dataTransfer.date = getFormatDateComplete(
        data_.month + "-" + data_.day + "-" + data_.year,
        2
      );
      dataTransfer.debtorCaseId = props.debtorCaseId;
    };

    const submit = async () => {
      const url = process.env.VUE_APP_BASE_URL + "/Transfer";
      let response = null;
      try {
        response = await axios.post(url, dataTransfer, {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        });
      } catch (e: any) {
        response = e.response;
      }

      return response;
    };

    return {
      closeModal,
      submit,
      dataTransfer,
      data_,
      setDate,
    };
  },
};
</script>
